// extracted by mini-css-extract-plugin
export var Section = "Management-module--Section--oCCKA";
export var SectionTitle = "Management-module--SectionTitle--7T+vE";
export var Title = "Management-module--Title--a8mlf";
export var Text = "Management-module--Text--co4KL";
export var Content = "Management-module--Content--EISQn";
export var arrowLeft = "Management-module--arrowLeft--6bdvc";
export var arrowRight = "Management-module--arrowRight--RjwVu";